<template>
  <div style="position:relative">
    <div class="top-header" id="fix-nav">
      <div class=" navbox" style="width: 1344px; margin: 0 auto">
        <div class="logo hand">
          <a @click="$router.push('/home')"
            ><img src="../assets/img/home/BEYEBEAI.png" height="30" width="150"
          /></a>
        </div>
        <nav class="top-nav">
          <ul id="top-nav">
            <li><router-link to="/">Home</router-link></li>
            <li>
              <router-link class="scroll" to="/product1" id="production"
                >Products</router-link
              >
              <div class="submenu" id="submenu2">
                <ul>
                  <li>
                    <a @click="$router.push('/product1')">
                      <span class="child-nav">The Driver Managment System</span>
                    </a>
                  </li>
                  <li>
                    <a @click="$router.push('/emu')">
                      <span class="child-nav">Automatic EMU Maintenance Robot</span>
                    </a>
                  </li>
                  <li>
                    <a @click="$router.push('/product2')">
                      <span class="child-nav"
                        >The Tunnel Inspection System</span
                      >
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <router-link to="/solution1" id="production"
                >Solutions</router-link
              >
              <div class="submenu" id="submenu2" style="padding: 0 196px;">
                <ul>
                  <li>
                    <a @click="$router.push('/solution2')">
                      <span class="child-nav"
                        >Smart Tunnel lnspection System</span
                      >
                    </a>
                  </li>
                  <li>
                    <a @click="$router.push('/solution1')">
                      <span class="child-nav"
                        >Whole-process Smart Driver Management System
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <!-- 周总要求的176，不关我事 -->
            <li style="width: 176px;">
              <router-link to="/aboutus" id="production"
                >About BEYEBE.AI</router-link
              >
              <div class="submenu" id="submenu2" style="padding: 0 296px;">
                <ul>
                  <li>
                    <a href="#Company">
                      <span class="child-nav">Company</span>
                    </a>
                  </li>
                  <li>
                    <a href="#Join">
                      <span class="child-nav">Join US </span>
                    </a>
                  </li>
                  <li>
                    <a href="#Events">
                      <span class="child-nav">Events </span>
                    </a>
                  </li>
                  <li>
                    <a href="#Contact">
                      <span class="child-nav">Contact US </span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <br />
        </nav>
      </div>
    </div>
    <!-- 头部整体盒子 -->
    <div
      id="header"
      :style="{ 'background-image': 'url(' + bgimageFromP + ')' }"
      class="container-fuild"
    >
      <!-- 电脑导航 -->
      <div class="header-nav container hidden-xs">
        <!-- 首页 home -->
        <div v-if="navIndex == 0">
          <div class="header-text font-ExtraBold">
            <div>Intelligent Railway AI <span>&</span></div>
            <div>Big Data Solution Expert</div>
          </div>
          <div
            class="header-button font-bold"
            @click="$router.push('/aboutus')"
          >
            For details
          </div>
        </div>
        <!-- product1 -->
        <div v-if="navIndex == 1 && currentPath == '/product1'">
          <div class="header-text font-bold">
            <div>Driver Management and</div>
            <div>Analysis System</div>
          </div>
          <div class="product1-text-b font-Regular">
            A smart at-station analysis device helps standardize flow management
            and ensures travel safety.
          </div>
        </div>
        <!-- product2 -->
        <div v-if="navIndex == 1 && currentPath == '/product2'">
          <div class="header-text font-bold">
            <div>The Smart Tunnel</div>
            <div>Inspection System</div>
          </div>
          <div class="product1-text-b font-Regular">
            Armed with A.I. technologies, the system automatically detects
            abnormalities in metro tunnels. This system is the first in the
            industry that solves the following incumbent problems in the
            maintenance of metro tunnels:
            <div>
              1. On-foot maintenance by naked eyes. manual entry into the log,
              fatigue due to long and late night labor. risk of missed tests and
              wrong judgements.
            </div>
            2. Lack of timely and comprehensive tests due to long tunnel Iength,
            short maintenance window and limited work hours.
            <div></div>
          </div>
        </div>
        <!-- solution1 -->
        <div v-if="navIndex == 2 && currentPath == '/solution1'">
          <div class="header-text font-ExtraBold">
            <div>Smart Driver Management</div>
            <div>and Analysis System</div>
          </div>
          <div class="product1-text-b font-Regular">
            Includes whole-process smart driver management and analysis and
            enforces a standardized operation flow.
          </div>
        </div>
        <!-- solution2 -->
        <div v-if="navIndex == 2 && currentPath == '/solution2'">
          <div class="header-text font-ExtraBold">
            <div>Smart Tunnel</div>
            <div>Inspection System</div>
          </div>
          <div class="product1-text-b font-Regular">
            AI-based Inspection automatically detects abnormalities in metro
            tunnels.
            <div>-Foreign Objects</div>
            <div>-Cables</div>
            <div>-Cracks</div>
            <div>-Leakages</div>
            <div>-Contact Net</div>
            <div>-Steel Rail</div>
            <div>-Equipment Cabinet</div>
          </div>
        </div>
        <!-- solution3 -->
        <div v-if="navIndex == 2 && currentPath == '/solution3'">
          <div class="header-text font-ExtraBold">
            <div>Big Data AI Based</div>
            <div>solution According</div>
            <div>to Customer Demand</div>
          </div>
          <div class="">
            <ul class="solution1-ul">
              <li v-for="(item, index) in solution1List" :key="index">
                <img
                  class="solution1_headerPic"
                  src="../assets/img/solution1/correct.png"
                  alt=""
                />
                <p class="solution1-ul-text2 font-ExtraBold">{{ item }}</p>
              </li>
            </ul>
          </div>
        </div>
        <!-- aboutus -->
        <div v-if="navIndex == 3">
          <div class="header-text font-ExtraBold">
            <div>Beyebe Is</div>
            <div>Innovator in Smart Traffic Management</div>
            <div class="product1-text-b font-Regular">
              Focusing on the fields of artificial intelligence, big data
              analysis and processing, data visualization, etc., we are
              committed to the development and service of artificial
              intelligence applications in the railway industry and provide a
              full range of artificial intelligence solutions for railway
              industry customers.
            </div>
          </div>
        </div>
        <!-- emu -->
        <div v-if="navIndex == 58">
          <div class="header-text font-ExtraBold">
            <div>Automatic EMU</div>
            <div>Maintenance Robot</div>
            <div class="product1-text-b font-Regular">
              Robots that can recognize EMU model, autonomously mobilize to the
              check point and take accurate photos of the parts
            </div>
          </div>
        </div>
        <!-- emu -->
        <div v-if="navIndex == 59">
          <div class="header-text font-ExtraBold">
            <div>Events</div>
            <div class="product1-text-b font-Regular">
              Throughout the years, we have grown into the leader in the
              application of and innovation in artificial intelligence and big
              data technology in China.
            </div>
          </div>
        </div>
      </div>

      <!-- 手机导航 -->
      <div class="header-nav-m container-fuild visible-xs">
        <div class="header-nav-logo-img">
          <img class="header-nav-logo" src="../assets/img/home/BEYEBEAI.png" />
        </div>
        <!-- 导航栏 -->
        <div class="header-nav-m-menu text-center">
          {{ menuName }}
          <div
            class="header-nav-m-menu-wrapper"
            data-toggle="collapse"
            data-target="#menu"
            @click="menuClick"
          >
            <span :class="menuClass"></span>
          </div>
          <!-- 导航内容 -->
          <div id="menu" class="header-nav-m-wrapper collapse">
            <div
              v-for="(item, index) in navList"
              :key="index"
              :class="index == navIndex ? 'active' : ''"
            >
              <div @click.stop="goToPath(item.path)">
                {{ item.name }}
              </div>
              <div
                class="pathChildren"
                @click="goToPath(i.path)"
                v-for="(i, n) in item.children"
                :key="n"
              >
                {{ i.name }}
              </div>
            </div>
          </div>
        </div>
        <!-- home -->
        <div v-if="navIndex == 0">
          <div class="header-text-phone font-ExtraBold">
            <div>Intelligent Railway AI <span>&</span></div>
            <div>Big Data Solution Expert</div>
          </div>
          <div class="header-button-out" @click="$router.push('/aboutus')">
            <div class="header-button-phone">For details</div>
          </div>
        </div>
        <!-- product1 -->
        <div v-if="navIndex == 1 && currentPath == '/product1'">
          <div class="header-text-phone font-ExtraBold">
            <div>Driver Management and</div>
            <div>Analysis System</div>
          </div>
        </div>
        <!-- product2 -->
        <div v-if="navIndex == 1 && currentPath == '/product2'">
          <div class="header-text-phone font-ExtraBold">
            <div>The Smart Tunnel</div>
            <div>Inspection System</div>
          </div>
        </div>
        <!-- solution1 -->
        <div v-if="navIndex == 2 && currentPath == '/solution1'">
          <div class="header-text-phone font-ExtraBold">
            <div>Smart Driver Management</div>
            <div>and Analysis System</div>
          </div>
        </div>
        <!-- solution2 -->
        <div v-if="navIndex == 2 && currentPath == '/solution2'">
          <div class="header-text-phone font-ExtraBold">
            <div>Smart Tunnel</div>
            <div>Inspection System</div>
          </div>
        </div>
        <!-- solution3 -->
        <div v-if="navIndex == 2 && currentPath == '/solution3'">
          <div class="header-text-phone font-ExtraBold">
            <div>Big Data AI Based</div>
            <div>solution According</div>
            <div>to Customer Demand</div>
          </div>
        </div>
        <!-- ABOUT US -->
        <div v-if="navIndex == 3">
          <div class="header-text-phone font-ExtraBold">
            <div>Beyebe Is</div>
            <div>Innovator in Smart Traffic Management</div>
          </div>
        </div>
        <!-- 不存在于导航的页面 -->
        <!-- emu -->
        <div v-if="navIndex == 58">
          <div class="header-text-phone font-ExtraBold">
            <div>Automatic EMU</div>
            <div>Maintenance Robot</div>
          </div>
        </div>
        <!-- emu -->
        <div v-if="navIndex == 59">
          <div class="header-text-phone font-ExtraBold">
            <div>Events</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: ["bgimageFromP", "navIndex", "menuName"],
  data() {
    return {
      menuClass: "glyphicon glyphicon-menu-down",
      bgimageConst: "",
      currentPath: this.$route.path,
      productList: [
        {
          title: "Collection of Images",
          context:
            "With the high-definition camera onboard, the 360° panoramic vision of the metro tunnel is obtained.",
          img: require("../assets/img/product/headerTips_1.png")
        },
        {
          title: "Smart Analysis",
          context:
            "Armed with the A.I. analysis technology, smart inspection and analysis of tunnel images shot in 5 different scenarios are realized.",
          img: require("../assets/img/product/headerTips_2.png")
        },
        {
          title: "Timely Alarm",
          context:
            "Alarms can be sent using real-time broadcast, short messages, emails, WeChat, cellphone APP, pop-up windows, or direct access to the operation center.",
          img: require("../assets/img/product/headerTips_3.png")
        },
        {
          title: "Professional Report",
          context:
            "Brief reports can be generated automatically. Custom-made professional reports can also be made on-demand.",
          img: require("../assets/img/product/headerTips_4.png")
        }
      ],

      navList: [
        {
          name: "Home",
          path: "/",
          children: []
        },
        {
          name: "Products",
          path: "/product1",
          children: [
            {
              name: "The Driver Managment System",
              path: "/product1",
              img: require("../assets/img/product2/select1.png")
            },
            {
              name: "Automatic EMU Maintenance Robot",
              path: "/emu",
              img: require("../assets/img/events/bg.png")
            },
            {
              name: "The Tunnel Inspection System",
              path: "/product2",
              img: require("../assets/img/product2/select2.png")
            }
          ]
        },
        {
          name: "Solutions",
          path: "/solution1",
          children: [
            {
              name: "Smart Tunnel lnspection System",
              path: "/solution2",
              img: require("../assets/img/solution1/nav3.png")
            },
            {
              name: "Whole-process Smart Driver Management System",
              path: "/solution1",
              img: require("../assets/img/solution1/nav2.png")
            }
            // ,
            // {
            //   name: "Whole-process Smart Driver Management system",
            //   path: "/solution1",
            //   img: require("../assets/img/solution1/nav1.png")
            // }
          ]
        },
        {
          name: "About BEYEBE.AI",
          path: "/aboutus",
          children: []
        }
      ],
      solution1List: [
        "Reduces cost",
        "Boosts the performance of end-to-end analytics workflows",
        "Saves time",
        "Easily scales from a workstation to multi-node clusters, as well as deploys during the process",
        "Rapidly provides a foundation for a new high-performance data science ecosystem through interoperability",
        "Integrates with leading data science frameworks as well as numerous deep learning frameworks",
        "All data are stored for future analysis, proving solid database for optimization of management"
      ]
    };
  },
  mounted() {},
  methods: {
    goToPath(path) {
      if (this.$route.path == path) {
        return;
      }
      this.$router.push(path);
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
.container {
  width: 1360px !important;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.product1-text-b {
  width: 570px;
  font-size: 17px;
  color: #ffffff;
  line-height: 25px;
  margin-top: 50px;
  opacity: 0.8;
}
.navi {
  width: 100%;
  height: 44px;
  line-height: 44px;
}
.drop_div {
  background-image: url("../assets/img/home/1.png");
}
/* 顶部 */
#header {
  /* background-image: url("../assets/img/home/headbg.png"); */
  transition: all ease 0.6s;
  background-size: cover;
  width: 100%;
  height: 800px;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #header {
    height: auto;
    padding-bottom: 30px;
  }
  #header .header-button-phone {
    font-size: 18px !important;
    width: 155px !important;
    height: 42px !important;
    margin-top: 0 !important;
  }
}
#header .header-text {
  width: 100%;
  height: 126px;
  font-size: 54px;

  font-weight: bold !important;
  color: #ffffff;
  line-height: 75px;
  margin-top: 170px;
  text-shadow: 0px 0px 81px rgba(123, 141, 182, 0.74);
}
#header .header-text p {
  margin-top: 50px;
  font-size: 20px;

  font-weight: bold;
  color: #ffffff;
  width: 50%;
  line-height: 50px;
}
#header .header-text-phone {
  width: 100%;
  font-size: 20px;

  font-weight: bold !important;
  color: #ffffff;
  margin: 15px 0;
  text-align: center;
  /* margin-top: 50px; */
  text-shadow: 0px 0px 81px rgba(123, 141, 182, 0.74);
}
#header .header-text span,
#header .header-text-phone span {
  color: #0a6cff;
}
#header .header-button {
  width: 202px;
  height: 58px;
  background: #0a6cff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 22px;
  font-family: PingFang SC;
  cursor: pointer;
  margin-top: 100px;
}
#header .header-button-phone {
  width: 202px;
  height: 58px;
  background: #0a6cff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 37px;
  font-family: PingFang SC;
  cursor: pointer;
  margin-top: 100px;
}
.header-button-out {
  display: flex;
  justify-content: center;
  width: 100%;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 100%;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 200px;
  height: 153px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
}
.header-nav-logo-img {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.header-nav-logo-img img {
  width: 126px;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 160px;
  float: right;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 30px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #ffff;
  font-size: 15px;
  font-weight: bold;
  padding: 5px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  /* left: 50%; */
  width: 0;
  height: 4px;
  opacity: 0;
  transition: all 0.6s ease;
  background: linear-gradient(90deg, #0a6cff 0%, rgba(11, 104, 245, 0) 100%);
  border-radius: 3px;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #0a6cff;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #0a6cff;
  text-decoration: none;
  border-bottom: 2px solid #0a6cff;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  top: 70%;
  left: -300%;
  z-index: 999999;

  background: transparent;
  z-index: 999;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  height: 112px;
  width: 220px;
  padding: 10px;
  margin-right: 10px;
  /* border-bottom: 1px solid #ccc; */
  box-shadow: 0 0 3px 1px #ccc;
  display: flex;
  flex-direction: column-reverse;
  /* background-image: url('../assets/img/product2/select1.png'); */
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  transform: scale(1.2);
  transition: all 0.3s ease;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  font-size: 14px;

  font-weight: bold;
  color: #ffffff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: flex;
  flex-direction: row;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  /* background: #ccc; */
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff !important;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #6e6e6e;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
.product2_headerPic {
  width: 52px !important;
  height: 52px !important;
}
/* 媒体查询*/
@media screen and (min-width: 751px) and (max-width: 975px) {
  #header .header-nav .header-nav-wrapper > li {
    margin: 0 10px;
  }
  #header .header-text {
    font-size: 38px;
  }
  .product-ul > li {
    margin-right: 5px;
    width: 150px !important;
  }
  .product-ul {
    flex-wrap: wrap;
    bottom: 50px !important;
  }
}
/* 媒体查询1360 */
@media screen and (max-width: 1360px) {
  #header {
    height: auto;
  }
  .product-ul > li {
    margin-right: 5px;
    width: 250px !important;
  }
}
.pathChildren {
  font-size: 12px;
}
.solution1-ul {
  display: flex;
  flex-direction: column;
  margin-top: 150px;
}
.solution1-ul li {
  display: flex;
  align-items: center;
}
.solution1-ul img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin: 10px 7px 5px 7px;
}
.solution1-ul .solution1-ul-text2 {
  font-size: 18px;

  font-weight: bold;
  color: #ffffff;
  line-height: 46px;
  opacity: 0.87;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue